<script lang="ts">

  import { ImageWithFallback } from "$lib/components/ui/image-with-fallback"
  import type { Product } from "../_types"

  type Props = {
    product: Product
    onSelect: (product: Product) => void
  }

  let { product, onSelect }: Props = $props()

</script>

<button
  type="button"
  class="w-full rounded-md border text-start"
  onclick={() => onSelect(product)}
>
  <ImageWithFallback
    class="h-40 rounded-b-none text-center"
    src={product.image_url}
    alt={product.name}
  />
  <div class="p-2 text-xs">
    <div class="font-bold">{product.name}</div>
    {#if product.discount_percentage === 0}
      <div class="text-muted-foreground">{product.price.toLocaleString("en-US")}</div>
    {:else if product.discount_percentage > 0 && product.price > 0}
      <div>
        {#if product.discount_percentage > 0}
          <div class="text-muted-foreground">
            <span class="font-semibold">{product.price.toLocaleString("en-US")}</span>
            {" "}
            <span class="line-through">{product.price_raw.toLocaleString("en-US")}</span>
          </div>
        {/if}
      </div>
    {/if}
  </div>
</button>
